import { useState, useEffect } from 'react'
import PropTypes from "prop-types"

const Deelay = ({ms = 0, children, renderPlaceholder}) => {
  const [show, setShow] = useState(null)

  useEffect(() => {
    
    const timer = setTimeout(() => {
      setShow(true)
    }, ms);

    return () => {
      clearTimeout(timer)
    }
  }, [ms])

  return show
      ? children
      : (renderPlaceholder && renderPlaceholder()) || null

}



Deelay.propTypes = {
  children: PropTypes.node.isRequired,
  renderPlaceholder: PropTypes.func,
  ms: PropTypes.number,
}

export default Deelay